import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Magnetic from "@/components/shared/Magnetic";

export default function CTABlock() {
  return (
    <section data-testid="cta-block" className="relative py-8 md:py-10 border-t border-white/5">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="rounded-3xl border border-white/10 bg-zinc-950/60 p-8 md:p-14 relative overflow-hidden">
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-white/[0.04] blur-3xl" />
          <div className="relative">
            <h2 className="font-display font-bold text-4xl md:text-6xl lg:text-7xl tracking-tight max-w-3xl text-balance">
              Let's build your <span className="italic font-light">next hit.</span>
            </h2>
            <p className="mt-6 max-w-xl text-zinc-400 text-lg">
              Book a 30-minute strategy call. We'll show you exactly how we'd approach your next release.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Magnetic radius={140} strength={0.4}>
                <Link
                  to="/contact"
                  data-testid="cta-book-call"
                  className="inline-flex items-center gap-2 bg-white text-black font-semibold rounded-full px-6 py-3.5 hover:bg-zinc-200 btn-magnetic glow-cta"
                >
                  Book Strategy Call <ArrowUpRight size={18} />
                </Link>
              </Magnetic>
              <Link
                to="/case-studies"
                className="inline-flex items-center gap-2 border border-white/20 text-white font-medium rounded-full px-6 py-3.5 hover:bg-white/5 transition-all"
              >
                View Case Studies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
